import { useEffect, useState } from 'react'

import { CONTRACT_LIST_API } from '../../../../../constants/api'
import { SUBMENU_DEFAULT_VALUE } from '../../../../../constants/route'
import { useSelection } from '../../../../../hooks'
import { useAsyncTable } from '../../../../Table'
import {
  getEntityTabFilterStateApi,
  updateEntityTabTableConfig,
} from '../../../EntityTab.api'
import { getContractsPermanentFilters } from '../../EntityTabContracts.utils'

export function useEntityTabContractsTable({
  containerRef,
  entity,
  objectId,
  scopeFilterKey,
  sub = SUBMENU_DEFAULT_VALUE,
}) {
  const [isConfigOpen, setConfigOpen] = useState(false)

  const extraFilters = {
    ...(scopeFilterKey ? { [scopeFilterKey]: [objectId] } : null),
    sub_menu: sub,
  }

  const filterStateApi = getEntityTabFilterStateApi({
    entityPlural: entity.plural,
    objectId,
    sub,
  })

  const asyncTable = useAsyncTable({
    containerRef,
    entity,
    extraFilters,
    filterStateApi,
    getPermanentFilters: getContractsPermanentFilters,
    listApi: CONTRACT_LIST_API,
    sub,
    withoutSubMenu: true,
  })

  const selection = useSelection({
    data: asyncTable.items,
    pagination: asyncTable.pagination,
  })

  useEffect(() => {
    selection.handleCleanSelection()
  }, [asyncTable.filterValues, objectId, sub])

  async function handleApplyConfig(obj) {
    return updateEntityTabTableConfig(
      { columns: asyncTable.columns, ...obj },
      entity.plural
    )
  }

  function handleConfigOpen() {
    setConfigOpen(true)
  }

  async function handleRefresh() {
    selection.handleCleanSelection()

    return asyncTable.handleReload()
  }

  return {
    ...asyncTable,
    ...selection,
    handleApplyConfig,
    handleConfigOpen,
    handleRefresh,
    isConfigOpen,
    setConfigOpen,
  }
}
